// @ts-nocheck
import { createTheme } from '@material-ui/core/styles';
import { darken, lighten } from '@material-ui/core/styles/colorManipulator';
import { COLORS } from 'src/constants/Color';

const paletteTheme = createTheme({
  palette: {
    primary: {
      main: COLORS.primary,
      light: lighten(COLORS.primary, 0.3),
      dark: darken(COLORS.primary, 0.3),
      contrastText: COLORS.white,
    },
    secondary: {
      main: COLORS.secondary,
      light: lighten(COLORS.secondary, 0.3),
      dark: darken(COLORS.secondary, 0.3),
      contrastText: COLORS.white,
    },
    action: {
      main: COLORS.action,
      light: lighten(COLORS.action, 0.3),
      dark: darken(COLORS.action, 0.3),
      contrastText: COLORS.white,
    },
    disabled: {
      main: COLORS.action,
      light: lighten(COLORS.action, 0.3),
      dark: darken(COLORS.action, 0.3),
      contrastText: COLORS.white,
    },
    warning: {
      main: COLORS.amber,
      light: lighten(COLORS.amber, 0.3),
      dark: darken(COLORS.amber, 0.3),
      contrastText: COLORS.white,
    },
    background: {
      paper: COLORS.white,
      default: COLORS.background,
    },
  },
});

// A custom theme for this app
const theme = createTheme({
  overrides: {
    MUIRichTextEditor: {
      root: {
        width: '100%',
      },
      editor: {
        minHeight: '50px',
        overflow: 'auto',
      },
      container: {
        padding: '8px',
        '&:hover': {
          background: COLORS.background,
        },
      },
    },
    MuiListItemIcon: {
      root: {
        color: undefined,
        minWidth: 32,
      },
    },
    MuiListItem: {
      root: {
        '&$selected': {
          backgroundColor: paletteTheme.palette.primary.main,
          color: paletteTheme.palette.primary.contrastText,

        },
        '&$selected:hover': {
          backgroundColor: paletteTheme.palette.primary.light,
          color: paletteTheme.palette.primary.contrastText,
        },
      },
      gutters: {
        paddingLeft: '12px',
        paddingRight: '12px',
      },
      button: {
        '&:hover': {
          backgroundColor: paletteTheme.palette.primary.light,
          color: paletteTheme.palette.primary.contrastText,
        },
      },
    },
    MuiButton: {
      root: {
        textTransform: 'none',
      },
    },
    MuiTypography: {
      subtitle2: {
        fontFamily: 'Qanelas-Bold',
        fontWeight: 'bold',
      },
    },
    MuiSelect: {
      select: {
        '&:focus': {
          backgroundColor: 'white',
        },
      },
    },
  },
  typography: {
    button: {
      textTransform: 'none',
    },
  },
}, paletteTheme);

export default theme;
